const sortAttr = "data-sort";

const getCellValue = (tr: HTMLTableRowElement, idx: number) => {
    const value = tr.children[idx].hasAttribute(sortAttr) ? tr.children[idx].getAttribute(sortAttr) : tr.children[idx].textContent;
    return value ? value.trim() : "";
};

export const getComparer =
    (numerical: boolean) => (idx: number, asc: boolean) => (a: HTMLTableRowElement, b: HTMLTableRowElement) => {
        return numerical
            ? getCellValue(asc ? a : b, idx).localeCompare(getCellValue(asc ? b : a, idx), undefined, { numeric: true })
            : getCellValue(asc ? a : b, idx).localeCompare(getCellValue(asc ? b : a, idx));
    };
